import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SFormService {

  constructor() { }

  /**
   *
   * @param formGroup 校验表单
   */
  validateForm(formGroup) {
    for (const key in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(key)) {
        formGroup.controls[key].markAsDirty();
        formGroup.controls[key].updateValueAndValidity();
      }
    }
    return formGroup.valid;
  }
  /**
   *
   * @param formGroup 获取表单数据
   */
  getFormValue(formGroup) {
    return formGroup.value;
  }
  /**
   *
   * @param formGroup 重置表单
   * @param data 重置表单为默认数据
   */
  resetForm(formGroup, data?) {
    if (data) {
      formGroup.patchValue(data);
    } else {
      formGroup.reset();
      for (const key in formGroup.controls) {
        if (formGroup.controls.hasOwnProperty(key)) {
          formGroup.controls[key].markAsPristine();
          formGroup.controls[key].updateValueAndValidity();
        }
      }
    }
    return formGroup;
  }

  reSet(formGroup, data) {
    formGroup.reset(data);
  }
  submit() {

  }
}
